import { handleErrorApi } from "../helpers/randoms";
import TrackingAbmService from "../services/TrackingAbmService";
import { types } from "../types/types";
import { finishSpinner, startSpinner } from "./ui/spinner";

export const getTracking = (idTipoTracking, idCampoClave) => {
    return async (dispatch) => {
      dispatch(startSpinner());
      try {
        const result = await TrackingAbmService.getTrackingEfectorDenunciaInternacion(
          idTipoTracking, idCampoClave
        );
        const body = await result.json();
        if (!result.ok) {
          throw body;
        }
        dispatch({
          type: types.trackingAbmGetTrackingSuccess,
          payload: body,
        });
      } catch (error) {
        dispatch({
          type: types.trackingAbmGetTrackingError,
        });
        handleErrorApi(
          dispatch,
          error,
          "Error al obtener el tracking.",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
      dispatch(finishSpinner());
    };
  };